// Web Push helper utilities.
import { pushPublicKey, pushSubscribe, pushUnsubscribe } from "../../lib/api";

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window;
}

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return null;
  return reg.pushManager.getSubscription();
}

export async function enablePush(token) {
  if (!pushSupported()) throw new Error("Push is not supported on this device.");
  const reg = await navigator.serviceWorker.ready;
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notifications blocked. Enable them in system settings.");

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const pub = await pushPublicKey();
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(pub),
    });
  }
  const json = sub.toJSON();
  await pushSubscribe(token, {
    endpoint: json.endpoint,
    keys: json.keys,
    user_agent: navigator.userAgent,
  });
  return sub;
}

export async function disablePush(token) {
  const sub = await currentSubscription();
  if (!sub) return false;
  const json = sub.toJSON();
  try {
    await pushUnsubscribe(token, { endpoint: json.endpoint, keys: json.keys });
  } catch {
    /* ignore */
  }
  await sub.unsubscribe();
  return true;
}
